import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed. Premium picks inbound.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-[#FAFAFA] mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="overline text-[#A1A1AA]">Newsletter</p>
          <h3 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter mt-4 max-w-xl">
            Weekly drops. Zero noise.
          </h3>
          <form onSubmit={submit} className="mt-8 flex max-w-md border-b border-white/30">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 bg-transparent py-3 outline-none placeholder:text-white/40 text-white"
            />
            <button
              data-testid="newsletter-submit"
              disabled={loading}
              className="px-6 py-3 text-sm uppercase tracking-wider font-semibold hover:text-[#E53935] transition-colors"
            >
              {loading ? "..." : "Subscribe →"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <p className="overline text-[#A1A1AA]">Shops</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Etsy</li>
            <li>Amazon</li>
            <li>Shopify</li>
            <li>Shop.com</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline text-[#A1A1AA]">Site</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>About</li>
            <li>Disclosure</li>
            <li>Privacy</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline text-[#A1A1AA]">Notice</p>
          <p className="mt-4 text-xs text-white/60 leading-relaxed">
            As an affiliate of these platforms, we earn from qualifying purchases at no extra cost to you.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-wrap justify-between text-xs text-white/40 gap-3">
          <span>© {new Date().getFullYear()} Curated / Four</span>
          <span className="font-display tracking-tighter">CURATED&nbsp;/&nbsp;FOUR&nbsp;—&nbsp;FOUR PLATFORMS. ONE TASTE.</span>
        </div>
      </div>
    </footer>
  );
}
